var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.056 2.4c-5.067 0-9.249 3.84-9.8 8.761h-2.01a.404.404 0 0 0-.31.666l2.966 3.491c.162.19.455.19.617 0l2.964-3.49a.404.404 0 0 0-.307-.667h-1.86c.54-3.792 3.801-6.721 7.74-6.721 4.77 0 8.558 4.291 7.705 9.216-.539 3.11-3.004 5.65-6.097 6.272-2.814.568-5.591-.385-7.428-2.43a.427.427 0 0 0-.588-.056l-.917.743a.437.437 0 0 0-.059.625c2.428 2.74 6.181 3.952 9.927 2.999 3.658-.93 6.494-4.015 7.16-7.732C23.874 7.843 19.089 2.4 13.056 2.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.105 15.9-3.48-1.462a1.02 1.02 0 0 1-.625-.94V7.2h2.039v5.62l2.856 1.2-.79 1.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.449bd748.svg";
export { ForwardRef as ReactComponent };